export *from './riskAssessment.component';


// WEBPACK FOOTER //
// ./app/insa-components/insa-risk-assessment/index.ts